type AgenciaLike =
  | string
  | number
  | {
      id?: string | number;
      nome?: string;
      label?: string;
      value?: string | number;
      filiais?: AgenciaLike[];
    };

function getAgenciaKey(agencia: AgenciaLike): string | undefined {
  if (typeof agencia === "string" || typeof agencia === "number") {
    return String(agencia);
  }

  return (
    (agencia.id !== undefined ? String(agencia.id) : undefined) ??
    (agencia.value !== undefined ? String(agencia.value) : undefined) ??
    agencia.nome ??
    agencia.label
  );
}

function flattenAgencias(agencias: AgenciaLike[]): AgenciaLike[] {
  const stack = [...agencias];
  const result: AgenciaLike[] = [];

  while (stack.length) {
    const current = stack.shift();
    if (!current) continue;

    result.push(current);

    if (typeof current !== "string" && typeof current !== "number") {
      if (Array.isArray(current.filiais)) {
        stack.unshift(...current.filiais);
      }
    }
  }

  return result;
}

export function getAgenciasFromUser(user?: {
  agencias?: AgenciaLike[];
  filiais?: AgenciaLike[];
  agencia?: AgenciaLike & { filiais?: AgenciaLike[] };
}): AgenciaLike[] {
  if (!user) return [];

  const base =
    (Array.isArray(user.agencias) && user.agencias) ||
    (Array.isArray(user.filiais) && [
      ...(user.agencia ? [user.agencia] : []),
      ...user.filiais,
    ]) ||
    (user.agencia && Array.isArray(user.agencia.filiais) && [
      user.agencia,
      ...user.agencia.filiais,
    ]) ||
    [];

  if (Array.isArray(user.agencias) && user.agencia) {
    const firstKey = base.length > 0 ? getAgenciaKey(base[0]) : undefined;
    const userKey = getAgenciaKey(user.agencia);

    if (firstKey && userKey && firstKey !== userKey) {
      return [user.agencia];
    }
  }

  const flattened = flattenAgencias(base);
  const seen = new Set<string>();
  const deduped: AgenciaLike[] = [];

  for (const agencia of flattened) {
    const key = getAgenciaKey(agencia);
    if (key && seen.has(key)) continue;
    if (key) seen.add(key);
    deduped.push(agencia);
  }

  return deduped;
}
